// extracted by mini-css-extract-plugin
module.exports = {"tbody":"TableBodyQ_tbody__1OU2g","columnContentScroll":"TableBodyQ_columnContentScroll__2CZn6","noResult":"TableBodyQ_noResult__1JX-P"};